module.exports = __webpack_public_path__ + "static/media/mainTopicMobileBlue.c2c17b27.svg";